import { downloadQbrPptxReport } from 'partner360/components/QBR'

import { IFinancialCockpitQbrDocument } from '../../../api/types'

export const downloadQbrDocumentPptx = (document: IFinancialCockpitQbrDocument): void => {
  if (!document.UID || !document.PPTXReport) {
    return
  }

  void downloadQbrPptxReport(document.UID, document.PPTXReport)
}
